import React, { useState } from 'react';
import Select from 'react-select';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const EventModal = ({ isOpen, setIsOpen, statusOptions, handleSubmit, couponform, image, handleChange, setCouponForm, handleThumbnailChange, preImage, setData }) => {
    const url=process.env.REACT_APP_LINK
    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Event Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="image" className="oms-form-label">
                            Image
                        </label>
                        <input
                            type="file"
                            id="image"
                            name='image'
                            accept="image/*"
                            // value={image}
                            onChange={handleThumbnailChange}
                        />
                        {
                            preImage ? <img style={{
                                width: "80px",
                                height: "50px"
                            }} src={`${url}/${preImage}`} alt="" /> : null
                        }

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="title" className="oms-form-label">
                            Title
                        </label>
                        <input
                            type="text"
                            id="title"
                            name='title'
                            value={couponform.title}
                            onChange={handleChange}
                            placeholder="Enter Title"

                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="short_description" className="oms-form-label">
                            Short Description
                        </label>

                        <input
                            type="text"
                            id="short_description"
                            name="short_description"
                            value={couponform.short_description}
                            onChange={handleChange}
                            placeholder="Enter Short Description"

                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="price" className="oms-form-label">
                            Joining Fee 
                        </label>
                        <input
                            type="number"
                            id="price"
                            name='price'
                            value={couponform.price}
                            onWheel={(e) => { e.target.blur() }}
                            onChange={handleChange}
                            placeholder='Enter Joining Fee'
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="join_fee" className="oms-form-label">
                            Discounted Joining Fee
                        </label>
                        <input
                            type="number"
                            id="join_fee"
                            name='join_fee'
                            value={couponform.join_fee}
                            onWheel={(e) => { e.target.blur() }}
                            onChange={handleChange}
                            placeholder='Enter Discounted Joining Fee'
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="win_amount" className="oms-form-label">
                            Winning Amount
                        </label>
                        <input
                            type="number"
                            id="win_amount"
                            name='win_amount'
                            value={couponform.win_amount}
                            onWheel={(e) => { e.target.blur() }}
                            onChange={handleChange}
                            placeholder='Enter Winning Amount'
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">
                            Event Terms
                        </label>
                        <ReactQuill
                            theme="snow"
                            value={couponform.description}
                            onChange={(value) =>
                                setData((prev) => ({ ...prev, description: value }))
                            }
                            style={{ backgroundColor: "#fefffc" }}
                            placeholder="Enter Description"
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EventModal;
